// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  BgpServiceCommunity,
  BgpServiceCommunitiesListOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a BgpServiceCommunities. */
export interface BgpServiceCommunities {
  /**
   * Gets all the available bgp service communities.
   * @param options The options parameters.
   */
  list(
    options?: BgpServiceCommunitiesListOptionalParams,
  ): PagedAsyncIterableIterator<BgpServiceCommunity>;
}
